import _ from 'lodash';

import { TestIdDomain } from 'constants/testIds';

const ProgramsAndPricingTestIdsScope = {
  RATE_SHEET_FORM: 'rate-sheet-form',
};

export const ProgramsAndPricingTestIds = {
  // ProgramDetails
  PROGRAM_ADDITIONAL_INFO_TABLE: `${TestIdDomain.PROGRAMS_AND_PRICING}.program-additional-info-table`,
  PROGRAM_ADJUSTMENTS_TABLE: `${TestIdDomain.PROGRAMS_AND_PRICING}.program-adjustments-table`,
  PROGRAM_ELIGIBILITY_TABLE: `${TestIdDomain.PROGRAMS_AND_PRICING}.program-eligibility-table`,
  PROGRAM_INVESTOR_WARNINGS: `${TestIdDomain.PROGRAMS_AND_PRICING}.program-investor-warnings-status`,
  PROGRAM_FINAL_PRICES_TABLE: `${TestIdDomain.PROGRAMS_AND_PRICING}.program-final-prices-table`,
  PROGRAM_RATES_TABLE: `${TestIdDomain.PROGRAMS_AND_PRICING}.program-rates-table`,
  RATES_RETRY_BUTTON: `${TestIdDomain.PROGRAMS_AND_PRICING}.rates-retry-button`,

  // ProgramSummary
  SEARCH_ID_BUTTON: `${TestIdDomain.PROGRAMS_AND_PRICING}.search-id-button`,
  ADJUSTMENTS_INFO_BUTTON: `${TestIdDomain.PROGRAMS_AND_PRICING}.adjustments-info-button`,

  // ProgramsFilterPanel
  BASE_FILTERS: `${TestIdDomain.PROGRAMS_AND_PRICING}.base-filters`,
  DESIRED_TARGET_INPUT: `${TestIdDomain.PROGRAMS_AND_PRICING}.desired-target-input`,
  PROGRAMS_FILTER_PANEL: `${TestIdDomain.PROGRAMS_AND_PRICING}.programs-filter-panel`,
  SEARCH_BUTTON: `${TestIdDomain.PROGRAMS_AND_PRICING}.search-button`,
  getDesiredTargetTypeButtonId: targetType =>
    `${TestIdDomain.PROGRAMS_AND_PRICING}.desired-target-${targetType}-button`,
  getCompensationFilterId: value =>
    `${TestIdDomain.PROGRAMS_AND_PRICING}.compensation-${value}-radio`,
  getFilterId: filterId => `${TestIdDomain.PROGRAMS_AND_PRICING}.${_.kebabCase(filterId)}-filter`,
  getFilterOptionId: (filterId, value) => `${_.kebabCase(filterId)}-filter.option-${value}`,

  // ProgramsTableHead
  COLUMN_STUB: `${TestIdDomain.PROGRAMS_AND_PRICING}.column-stub`,

  // ProgramsTableToolbar
  PROGRAMS_TABLE_TOOLBAR: `${TestIdDomain.PROGRAMS_AND_PRICING}.programs-table-toolbar`,
  HIDE_INELIGIBLE_SWITCH: `${TestIdDomain.PROGRAMS_AND_PRICING}.hide-ineligible-switch`,
  SHOW_EXPIRED_PRICING_SWITCH: `${TestIdDomain.PROGRAMS_AND_PRICING}.show-expired-pricing-switch`,

  // RateSheetForm
  RATE_SHEET_ID_SELECT: `${TestIdDomain.PROGRAMS_AND_PRICING}.rate-sheet-id-select`,

  // RateSheetForm (inline)
  RATE_SHEET_FORM_FROM_DATE_INPUT: `${ProgramsAndPricingTestIdsScope.RATE_SHEET_FORM}.from-date-input`,
  RATE_SHEET_FORM_TO_DATE_INPUT: `${ProgramsAndPricingTestIdsScope.RATE_SHEET_FORM}.to-date-input`,
  RATE_SHEET_FORM_RATE_SHEET_ID_AUTOCOMPLETE_INPUT: `${ProgramsAndPricingTestIdsScope.RATE_SHEET_FORM}.rate-sheet-id-autocomplete`,
  RATE_SHEET_FORM_RATE_SHEET_ID_OPTION: `${ProgramsAndPricingTestIdsScope.RATE_SHEET_FORM}.rate-sheet-id-option`,
  RATE_SHEET_FORM_CANCEL_BUTTON: `${ProgramsAndPricingTestIdsScope.RATE_SHEET_FORM}.cancel-button`,
  RATE_SHEET_FORM_CONFIRM_BUTTON: `${ProgramsAndPricingTestIdsScope.RATE_SHEET_FORM}.confirm-button`,
};
